import { FC, useEffect, useState } from "react";
import { PATH_ANALYTICS, TAB_ANALYTICS, TAB_ANALYTICS_INNER } from "constants/paths";
import StickyHeader from "../../Common/Components/StickyHeader";
import StickyHeaderAnalytics from "../../Common/Components/StickyHeaderAnalytics";
import TabsWrapper from "modules/Common/Components/TabsWrapper";
import AnalyticsTabOption from "../Shared/AnalyticsTabOption";
import styled from "styled-components";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import {
  ANALYTICS_ACCOUNTS_DATA,
  CONTACT_ANALYTICS,
  ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS,
  CONTACTS_INNER_ANALYTICS,
} from "constants/types";
import { useHistory, useLocation } from "react-router";
import { resetRedirectUrls } from "../actions";
import { getQueryPageSource, removeAccountContactIdFromQueryParams } from "utils";
import { getAnalyticsFilterId, getQueryCampaignId, getQueryEmailId, getQueryWorkflowId } from "modules/EmailBrowser/utils";
import useQuery from "../../../hooks/useQuery";

export type IAnalyticsHeaderSticky = {
  page: string;
  tab: string;
};

const AnalyticsHeaderSticky: FC<IAnalyticsHeaderSticky> = (props) => {
  const { page, tab } = props;
  const [showBack, setShowBack] = useState(false);
  const location = useLocation();
  const selectedPerson = useSelector((state: RootState) => state.contactAnalytics.selectedPerson);
  const selectedAccount = useSelector((state: RootState) => state.analyticsAccounts.selectedAccount);
  const xiq_internal_user = useSelector((state: RootState) => state.user.xiq_internal_user);
  const redirectUrlContacts = useSelector((state: RootState) => state.contactAnalytics.redirectUrl);
  const redirectUrlAccounts = useSelector((state: RootState) => {
    return state.accountsContentEngagement.redirectUrl === ""
      ? state.accountsContentEngagement.redirectUrl
      : state.accountsDashboard.redirectUrl;
  });
  let query = useQuery();
  const analyticsRedirectUrl = localStorage.getItem("analytics_back_url");
  const campaignId = getQueryCampaignId();
  const emailId = getQueryEmailId();
  const workflowId = getQueryWorkflowId();
  const fsId = getAnalyticsFilterId();

  let contactsDashboardUrl =
    window.location.search.length > 0
      ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_ANALYTICS_INNER.DASHBOARD}/${window.location.search}`
      : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_ANALYTICS_INNER.DASHBOARD}`;
  let contactsContentUrl =
    window.location.search.length > 0
      ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_ANALYTICS_INNER.CONTENT}/${window.location.search}`
      : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_ANALYTICS_INNER.CONTENT}/`;
  let accountsDashboardUrl =
    window.location.search.length > 0
      ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}/${TAB_ANALYTICS_INNER.DASHBOARD}/${window.location.search}`
      : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}/${TAB_ANALYTICS_INNER.DASHBOARD}`;
  let accountsContentUrl =
    window.location.search.length > 0
      ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}/${TAB_ANALYTICS_INNER.CONTENT}/${window.location.search}`
      : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}/${TAB_ANALYTICS_INNER.CONTENT}`;

  const history = useHistory();
  const getSubTabsTitle = () => {
    let label = "";
    let subTitle = "";
    if (tab === TAB_ANALYTICS_INNER.DASHBOARD || tab === TAB_ANALYTICS_INNER.CONTENT) {
      if (page === "accounts") {
        subTitle = selectedAccount ? selectedAccount : "";
        label = "Account Analytics";
      } else if (page === "contacts") {
        subTitle = selectedPerson
          ? selectedPerson?.contact_name?.trim() !== ""
            ? selectedPerson?.contact_name
            : selectedPerson?.contact_email
          : "";
        label = "Person Analytics";
      }
    }

    return { label: label, subTitle: subTitle };
  };
  const paramsWithOutAccountContactId = removeAccountContactIdFromQueryParams();
  const tabsArray = [
    {
      pillName: "Dashboard",
      to:
        window.location.search.length > 0
          ? window.location.search.includes("account_id") || window.location.search.includes("contact_id")
            ? `/${PATH_ANALYTICS}/${paramsWithOutAccountContactId}`
            : `/${PATH_ANALYTICS}/${window.location.search}`
          : `/${PATH_ANALYTICS}/`,
      isActive: page === undefined || page === "/",
      onClick: (e: any) => {
        store.dispatch({ type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET });
      },
    },
    {
      pillName: "Accounts",
      to:
        window.location.search.length > 0
          ? window.location.search.includes("account_id") || window.location.search.includes("contact_id")
            ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}${paramsWithOutAccountContactId}`
            : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}${window.location.search}`
          : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}`,
      isActive: page === TAB_ANALYTICS.ACCOUNTS,
      onClick: (e: any) => store.dispatch({ type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET }),
    },
    {
      pillName: "Contacts",
      isActive: page === TAB_ANALYTICS.CONTACTS,
      to:
        window.location.search.length > 0
          ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/delivered${window.location.search}`
          : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/delivered`,
      onClick: (e: any) => store.dispatch({ type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET }),
    },
    {
      pillName: "Content",
      isActive: page === TAB_ANALYTICS.CONTENT,
      to:
        window.location.search.length > 0
          ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTENT}/${window.location.search}`
          : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTENT}/`,
      onClick: (e: any) => store.dispatch({ type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET }),
    },
  ];

  const subTabsArray = [
    {
      pillName: "Dashboard",
      to: page === "contacts" ? contactsDashboardUrl : page === "accounts" ? accountsDashboardUrl : null,
      isActive: tab === "dashboard",
    },
    {
      pillName: "Content Engagement",
      to: page === "contacts" ? contactsContentUrl : page === "accounts" ? accountsContentUrl : null,
      isActive: tab === "content",
    },
  ];

  const redirectToListingPage = () => {
    const analyticsPage = history.location.pathname.split("/")[1];
    const pageSource = getQueryPageSource();
    if (pageSource === "analytics-content") {
      let queryParams = new URLSearchParams(window.location.search);

      if (queryParams.get("contact_id")) {
        queryParams.delete("contact_id");
      }
      if (queryParams.get("page_source")) {
        queryParams.delete("page_source");
      }
      history.push(
        `/analytics/content/${queryParams.toString().trim() !== "" ? "?" + queryParams.toString().trim() : ""}`
      );
      store.dispatch({
        type: CONTACTS_INNER_ANALYTICS.DASHBOARD_RESET,
      });
      store.dispatch({
        type: CONTACTS_INNER_ANALYTICS.CONTENT_RESET,
      });
      store.dispatch({
        type: CONTACT_ANALYTICS.SELECTED_PERSON_RESET,
      });
      return;
    }
    if (tab === TAB_ANALYTICS_INNER.DASHBOARD || tab === TAB_ANALYTICS_INNER.CONTENT) {
      if (page === "accounts") {
        store.dispatch({ type: ANALYTICS_ACCOUNTS_DATA.FILTER_RESET, payload: true });
        resetRedirectUrls();
        history.push(redirectUrlAccounts !== "" ? redirectUrlAccounts : fsId ? `/analytics?fs_id=${fsId}` : "/analytics");
        return;
      } else if (page === "contacts") {
        store.dispatch({ type: CONTACT_ANALYTICS.FILTER_RESET, payload: true });
        resetRedirectUrls();
        history.push(redirectUrlContacts !== "" ? redirectUrlContacts : fsId ? `/analytics?fs_id=${fsId}` : "/analytics");
        return;
      }
    } else if (analyticsPage === "analytics" && history.location.pathname.split("/").length) {
      if (page === "contacts" && window.location.search.includes("account_id")) {
        history.push(`/analytics/accounts/dashboard/${window.location.search}`);
        return;
      }
      if (analyticsRedirectUrl) history.push(analyticsRedirectUrl);
      if (workflowId) {
        let redirect = query.get("redirect");
        if (redirect === 'automation') {
          history.push(`/automation?fromId=${workflowId}`);
        } else {
          history.push(`/automation/details?workflow_id=${workflowId}`);
        }
      }
    }
    return undefined;
  };

  useEffect(() => {
    if (window.location.search.includes("account_id") || window.location.search.includes("contact_id"))
      setShowBack(true);
  }, []);

  useEffect(() => {
    if (tab === TAB_ANALYTICS_INNER.CONTENT || tab === TAB_ANALYTICS_INNER.DASHBOARD) {
      if (page === "accounts") {
        setShowBack(true);
      } else if (page === "contacts") {
        setShowBack(true);
      }
    } else if (page === "contacts" && window.location.search.includes("account_id")) {
      setShowBack(true);
    } else {
      setShowBack(false);
    }
    if (window.location.search.includes("campaign_id") || window.location.search.includes("email_id")) {
      setShowBack(true);
    }
    if (window.location.search.includes("workflow_id")) {
      setShowBack(true);
    }
  }, [tab, page]);

  useEffect(() => {
    // to remove the back button if user click on analytics from left sidebar
    if (!campaignId && !emailId && !workflowId && !(page === "contacts" || page === "accounts")) {
      setShowBack(false);
    }
  }, [campaignId, emailId, workflowId]);

  // title of the page selected using :page param
  const title = "Analytics";
  const { label, subTitle } = getSubTabsTitle();
  if (xiq_internal_user) {
    tabsArray.push({
      pillName: "Trends",
      isActive: page === TAB_ANALYTICS.TRENDS,
      to: `/${PATH_ANALYTICS}/${TAB_ANALYTICS.TRENDS}/${window.location.search}`,
      onClick: () => { },
    });
    tabsArray.push({
      pillName: "Insights",
      isActive: page === TAB_ANALYTICS.INSIGHTS,
      to: `/${PATH_ANALYTICS}/${TAB_ANALYTICS.INSIGHTS}/${window.location.search}`,
      onClick: () => { },
    });
  }
  return (
    <>
      <Wrapper>
        <StickyHeader>
          <StickyHeaderAnalytics
            label={tab === "dashboard" || tab === "content" ? label : ""}
            title={tab === "dashboard" || tab === "content" ? subTitle : title}
            showBack={showBack}
            externalRedirect={redirectToListingPage}
          >
            <TabsWrapper>
              <AnalyticsTabOption tabArray={tab === "dashboard" || tab === "content" ? subTabsArray : tabsArray} />
            </TabsWrapper>
          </StickyHeaderAnalytics>
        </StickyHeader>
      </Wrapper>
    </>
  );
};

export default AnalyticsHeaderSticky;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 57px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding-top: 47px;
  }
`;
